import { Glyph } from "../../types";

const SvgCheckCircle: Glyph = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 
             10-4.48 10-10S17.52 2 12 2zm-1 14.5l-4-4 
             1.41-1.41L11 13.67l5.59-5.59L18 9.5l-7 7z"
    />
  </svg>
);

export default SvgCheckCircle;
